import { AfterViewInit, Component, OnInit } from '@angular/core';

import { BaseService } from '../../../services/base.service';
import { AuthService } from '../../../services/auth.service';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import {MatCheckboxChange, MatSelectChange} from '@angular/material';
import {DistributorLocation} from '../../../models/distributor-location';
import {User} from '../../../models/user';
import {Market} from '../../../models/market';
import {MarketLevel} from '../../../models/market-level';
import {CustomerLocation} from '../../../models/customer-location';
import {TrackingLocation} from '../../../models/tracking-location';
import {Title} from '@angular/platform-browser';
import { TitleBroadcastService } from 'app/services/title-broadcast.service';

@Component({
  selector: 'app-distributor-customer-location-list',
  templateUrl: './distributor-customer-location-list.component.html',
  styleUrls: ['./distributor-customer-location-list.component.scss']
})
export class DistributorCustomerLocationListComponent implements OnInit {

    lat = 23.8383283;
    lng = 90.3759853;

    loggedUser: User;
    distributorLocationList: DistributorLocation[] = [];
    customerLocationList: CustomerLocation[] = [];
    loadingData = false;
    loadingDistributor = false;
    loadingCustomer = false;
    markets = [];
    selectedMarket: Market[] = [];
    marketLevels: MarketLevel[] = [];

    showDistributorLocation = false;
    showCustomerLocation = false;

    distributorCheckBoxSelected = false;
    customerCheckBoxSelected = false;

    showDistributorAndCustomerCheckBox: boolean;

    permissionForDistributorAndCustomer = false;
    loadDistributorMap = false;
    loadCustomerMap = false;

    viewer: string;

    filters = {
        'MarketIdList': null
    };


    private _unsubscribeAll: Subject<any>;

    constructor( private route: ActivatedRoute, private service: BaseService, private auth: AuthService, private titleService: Title ,private titleBroadcastService: TitleBroadcastService ) {
        this._unsubscribeAll = new Subject();

        this.loggedUser = auth.user;
        this.showDistributorLocation = this.auth.hasAccess('LOCATION', 'VIEW_DISTRIBUTOR_LOCATION');
        this.showCustomerLocation = this.auth.hasAccess('LOCATION', 'VIEW_CUSTOMER_LOCATION');

        this.marketLevels = this.loggedUser.MarketLevelHierarchy;
        this.marketLevels.forEach( marketLevel => {
            this.markets[ marketLevel.Rank ] = [];
            this.selectedMarket[ marketLevel.Rank ] = null;
        } );
    }

    ngOnInit(): void {
        this.service.getMarketList( { MarketLevelId: this.marketLevels[ 0 ].Id, Active: true } ).subscribe( pMarkets => this.markets[ 1 ] = pMarkets );

        if (this.showDistributorLocation && this.showCustomerLocation){
           this.showDistributorAndCustomerCheckBox = true;
           this.distributorCheckBoxSelected = true;
           this.customerCheckBoxSelected = true;
           this.viewer = 'Distributor/ Retailer';
        }
        this.titleService.setTitle('Distributor/ Retailer Location');
        this.titleBroadcastService.title.next('Distributor/ Retailer Location')
    }

    ngAfterViewInit(): void {
        this.service.getMarketList( {
            MarketLevelId: this.marketLevels[ 0 ].Id,
            Active       : true
        } ).subscribe( marketListResponse => {
            this.markets[ 1 ] = marketListResponse;
        } );
    }


    _resetChildDropdowns( pParentRank: number ): void {
        this.marketLevels.forEach( marketLevel => {
            if ( marketLevel.Rank > pParentRank ) {
                this.selectedMarket[ marketLevel.Rank ] = null;
                this.markets[ marketLevel.Rank ] = [];
            }
        } );
    }

    populateChildrenMarkets( event: MatSelectChange ): void {
        const market: Market = event.value;
        if ( market ) {
            this._resetChildDropdowns( market.MarketLevel.Rank );
            if ( this.marketLevels[ market.MarketLevel.Rank ] ) {
                this.service.getMarketList( {
                    MarketLevelId : this.marketLevels[ market.MarketLevel.Rank ].Id,
                    ParentMarketId: market.Id,
                    Active        : true
                } ).subscribe( marketListResponse => {
                    this.markets[ market.MarketLevel.Rank + 1 ] = marketListResponse;
                } );
            }
        }
        else {
            this._resetChildDropdowns( parseInt( event.source.id.slice( 6 ), 10 ) );
        }
    }

    getLocationList(): void {

        this.loadingData = true;
        this.filters.MarketIdList = null;
        for ( let i = this.selectedMarket.length - 1; i >= 0; i-- ) {
            if ( this.selectedMarket[ i ] ) {
                this.filters.MarketIdList = [ this.selectedMarket[ i ].Id ];
                break;
            }
        }

        if (this.showDistributorLocation && this.showCustomerLocation){
            this.permissionForDistributorAndCustomer = true;

            this.loadDistributorMap = this.distributorCheckBoxSelected;

            this.loadCustomerMap = this.customerCheckBoxSelected;


                if (this.loadDistributorMap){
                    this.loadingDistributor = true;
                    this.service.getDistributorLocationList( this.filters ).subscribe( locationList => {

                        if ( locationList.length > 0 ) {
                            this.lat = locationList[ 0 ].Latitude;
                            this.lng = locationList[ 0 ].Longitude;
                        }

                        this.distributorLocationList = locationList;
                        this.loadingDistributor = false;
                    }, error => {
                        this.loadingDistributor = false;
                    } );
                }

                if (this.loadCustomerMap){
                    this.loadingCustomer = true;
                    this.service.getCustomerLocationList( { MarketIdList: this.filters.MarketIdList} ).subscribe( locationList => {
                        this.customerLocationList = locationList;
                        this.loadingData = false;
                        this.loadingCustomer = false;
                        }, error => {
                            this.loadingData = false;
                        } );
                    }

        }


        else {
            if (this.showDistributorLocation && !this.showCustomerLocation){
                this.loadingDistributor = true;
                this.service.getDistributorLocationList( this.filters ).subscribe( locationList => {

                    if ( locationList.length > 0 ) {
                        this.lat = locationList[ 0 ].Latitude;
                        this.lng = locationList[ 0 ].Longitude;
                    }

                    this.distributorLocationList = locationList;
                    this.loadingDistributor = false;
                }, error => {
                    this.loadingDistributor = false;
                } );
            }

          if (this.showCustomerLocation && !this.showDistributorLocation){
              this.loadingCustomer = true;
              this.service.getCustomerLocationList( this.filters ).subscribe( locationList => {

                  if ( locationList.length > 0 ) {
                      this.lat = locationList[ 0 ].Latitude;
                      this.lng = locationList[ 0 ].Longitude;
                  }

                  this.customerLocationList = locationList;
                  this.loadingCustomer = false;
              }, error => {
                  this.loadingData = false;
                  this.loadingCustomer = false;
              } );
          }

        }

    }

}
